// extracted by mini-css-extract-plugin
export default {"select":"LaguageSelect_select__LNXD0"};